import { Box, Button } from "@mui/material";
import SearchIcon from "@mui/icons-material/Search";
import CircularProgress from "@mui/material/CircularProgress";
import "./ActionButton.scss";
import { Product } from "../util/Utils";
import { THEME } from "../util/LookupConst";

const ActionButton = (props: any) => {
  const setDisabled = () => {
    if (props?.disabled || props?.loading) {
      return true;
    } else {
      return false;
    }
  };

  return (
    <Box
      className={
        "action-btn " +
        (Product.ProductCode() === THEME.GA
          ? "theme-ga"
          : Product.ProductCode() === THEME.CRICO
          ? "theme-crico"
          : "theme-sa")
      }
    >
      {!props.upload && (
        <Button
          disabled={setDisabled()}
          variant="contained"
          type={props?.type || "submit"}
          className={
            props?.color === "red"
              ? "action-btn-red "
              : props?.color === "green"
              ? "action-btn-green"
              : props?.actionButtonStyle === "outline" && !setDisabled()
              ? "outline theme-border color-sec"
              : props?.actionButtonStyle === "dark" && !props?.disabled
              ? "black-button-bg-color"
              : !setDisabled()
              ? "theme-backgroung-color"
              : ""
          }
          fullWidth
          onClick={props?.onClick}
        >
          {props?.action === "search" && (
            <SearchIcon className="white font-20 margin-right-5" />
          )}

          {props?.label}
          {props?.loading && (
            <CircularProgress size={25} className="action-button-loader" />
          )}
          <input type="file" hidden />
        </Button>
      )}
      {props.upload && (
        <span>
          <input
            accept={props.accept}
            style={{ display: "none" }}
            id="raised-button-file"
            type="file"
            onChange={props.onChange}
          />
          <label htmlFor="raised-button-file" className="import-file">
            <Button
              component="span"
              className="black-button-bg-color"
              onClick={props?.onClick}
            >
              {props?.label}
            </Button>
          </label>
        </span>
      )}
    </Box>
  );
};

export default ActionButton;
